import gql from 'graphql-tag';

export const circleCreate = gql`
  mutation circleCreate($input: CircleCreateInput!) {
    circleCreate(input: $input) {
      circle {
        id
        name
        asset_image {
          id
          url
        }
        contacts {
          total
        }
      }
    }
  }
`;

export const circleUpdate = gql`
  mutation circleUpdate($input: CircleUpdateInput!) {
    circleUpdate(input: $input) {
      circle {
        id
        name
        asset_image {
          id
          url
        }
        contacts {
          total
        }
      }
    }
  }
`;

export const circleDelete = gql`
  mutation circleDelete($input: CircleDeleteInput!) {
    circleDelete(input: $input) {
      success
    }
  }
`;
